<template>
    <div class="footer">
       <div>
            <div class="footer-tel">客服电话 | 400-0080-960</div>
            <div class="footer-copy">
                <p>© 2016-2018 选址中国控股有限公司</p>
                <p>京ICP备16020840号</p>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>
    .footer {
        width: 100%; 
        background-color: #343434;
        text-align: center;
        height:2rem;
        display:flex;
        align-items: center;
        justify-content: center;
    }
    .footer-tel {
        font-size: .22rem;color: #ffffff;
    }
    .footer-copy {
        font-size: .18rem;color: #ffffff;
    }
</style>
